import { type Meta } from '../types/docs';

const META: Meta = {
  description: 'Called when a canvas is deleted',
  name: 'canvas_deleted',
  params: [
    {
      description: 'The id of the canvas',
      name: 'canvas_id',
      required: true,
      type: 'string',
    },
    {
      description: 'The id of the board the canvas was deleted from',
      name: 'board_id',
      required: false,
      type: 'string',
    },
    {
      description: 'The location from which the canvas was deleted',
      name: 'location',
      required: false,
      type: 'enum',
      values: ['board', 'canvases'],
    },
  ],
};

export default META;
